import React from "react";

export const IconPrintScanCopy = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m18 17.25h1.125c0.4968-0.0015 0.9729-0.1995 1.3242-0.5508s0.5493-0.8274 0.5508-1.3242v-7.5c-0.0015-0.49682-0.1995-0.97288-0.5508-1.3242s-0.8274-0.54933-1.3242-0.55081h-14.25c-0.49682 0.00148-0.97288 0.1995-1.3242 0.55081s-0.54933 0.82737-0.55081 1.3242v7.5c0.00148 0.4968 0.1995 0.9729 0.55081 1.3242s0.82737 0.5493 1.3242 0.5508h1.125"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m16.86 11.25h-9.72c-0.6296 0-1.14 0.5104-1.14 1.14v7.47c0 0.6296 0.5104 1.14 1.14 1.14h9.72c0.6296 0 1.14-0.5104 1.14-1.14v-7.47c0-0.6296-0.5104-1.14-1.14-1.14z"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m18 6v-1.125c-0.0015-0.49682-0.1995-0.97288-0.5508-1.3242s-0.8274-0.54933-1.3242-0.55081h-8.25c-0.49682 0.00148-0.97288 0.1995-1.3242 0.55081s-0.54933 0.82737-0.55081 1.3242v1.125"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m18.375 9.75c0.6213 0 1.125-0.50368 1.125-1.125s-0.5037-1.125-1.125-1.125-1.125 0.50368-1.125 1.125 0.5037 1.125 1.125 1.125z"
      fill="#000"
    />
  </svg>
);

export default IconPrintScanCopy;
